<template>
  <div class="ui segment">
    <div class="ui top attached label">
      <i class="exclamation circle icon"></i> Data access and use constraints:
    </div>
    <div>
      <b>Use constraints:</b>
      {{getI18n(dataConstraint.accessUseConstraint,"en")}}
    </div>
    <br>
    <div>
      <b>Data policy:</b>
      <a
        :href="getI18n(dataConstraint.urlDataPolicy,'en')"
      >{{getI18n(dataConstraint.urlDataPolicy,"en")}}</a>
    </div>
    <br>
    <div v-if="dataConstraint.embargo != null">
      <b>Access constraints:</b>
      Public with an embargo of {{dataConstraint.embargo.duration}} years.
    </div>
    <div v-else>
      <b>Access constraints:</b> Public
    </div>
    <br>
    <div v-if="dataConstraint.licence != null">
      <b>Licence:</b>
      <a :href="dataConstraint.licence.url">{{dataConstraint.licence.title}}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataConstraint"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>

<style>
</style>
